import { Select, MenuItem, FormControl } from '@mui/material';
import { useCurrency, Currency } from '../../contexts/CurrencyContext';

const currencies: { code: Currency; label: string; symbol: string }[] = [
    { code: 'GBP', label: 'GBP', symbol: '£' },
    { code: 'USD', label: 'USD', symbol: '$' },
    { code: 'EUR', label: 'EUR', symbol: '€' },
    { code: 'AUD', label: 'AUD', symbol: '$' },
    { code: 'INR', label: 'INR', symbol: '₹' },
];

export function CurrencyToggle() {
    const { currency, setCurrency } = useCurrency();

    return (
        <FormControl variant="standard" size="small">
            <Select
                value={currency}
                onChange={(e) => setCurrency(e.target.value as Currency)}
                disableUnderline
                sx={{
                    color: 'text.secondary',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    '& .MuiSelect-select': {
                        py: 0.5,
                        pr: '24px !important',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'text.secondary'
                    }
                }}
            >
                {currencies.map((c) => (
                    <MenuItem key={c.code} value={c.code} sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                        <span style={{ opacity: 0.7, width: 20 }}>{c.symbol}</span>
                        {c.code}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
